import { render, staticRenderFns } from "./SandBox.vue?vue&type=template&id=1378b158&"
import script from "./SandBox.vue?vue&type=script&lang=js&"
export * from "./SandBox.vue?vue&type=script&lang=js&"
import style0 from "./SandBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports